import { EMPTY, Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Servidor } from '../_classes/servidor';
import { RestService } from '../_servicos/rest.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Util } from '../_classes/util';
import { RamalEditarService } from '../_servicos/ramal-editar-service';
import { EnvService } from '../_servicos/env.service';

@Component({
  selector: 'app-ramal-servidor',
  templateUrl: './ramal-servidor.component.html',
  styleUrls: ['./ramal-servidor.component.scss'],
})
export class RamalServidorComponent implements OnInit {
  // @Input() servidorSrh2: ServidorSrh2;

  carregando = false;
  mostrarEdicaoRamal: boolean = false;
  ramal = '';

  // servidor$: Observable<Servidor>;
  servidor: Servidor;
  servidor$: Observable<Servidor>;

  // servidorSrh2$: Observable<ServidorSrh2>;

  mostrarAjuda = false;
  erros$ = new Subject<boolean>();

  constructor(
    private alertService: ModalAlertaService,
    private ramalEditarService: RamalEditarService,
    private service: RestService,
    private env: EnvService
  ) {
    this.carregando = true;
  }
  //  se nnão tiver ramal preciso mostrar.
  //  de inicio mostrar sempre

  ngOnInit() {
    this.atualizar();
  }

  editarRamal() {
    this.mostrarEdicaoRamal = !this.mostrarEdicaoRamal;
  }

  handleError(e: any) {
    //console.log(e);
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro ao incluir ramal, tente novamente',
      e
    );
  }

  gravarRamal() {
    if (this.servidor) {
      if (this.servidor.servidorSrh2) {
        if (this.ramal) {
          let ramalTemporario = this.servidor.servidorSrh2.nrFnTrbSrv;
          this.servidor.servidorSrh2.nrFnTrbSrv = this.ramal;
          //console.log(this.servidor.servidorSrh2);
          this.service.setRamal(this.servidor.servidorSrh2).subscribe(
            (x) => {
              //'jáchamou gravar ', x);
              this.atualizar();
              this.ramalEditarService.emitir(false);
              //this.temRamal = this.servidor.servidorSrh2.nrFnTrbSrv !== '';
              //this.mostrarEdicaoRamal =  (this.ramal === '');
            },
            (e) => {
              this.servidor.servidorSrh2.nrFnTrbSrv = ramalTemporario;
              this.handleError(e);
              return EMPTY;
            }
          );
        }
      }
    }
  }

  atualizar() {
    this.carregando = true;
    /*const source = timer(10000);
    const subscribe = source.subscribe(v => {
      this.carregando = false;
    });*/
    this.servidor = this.env.servidor;

    if (this.servidor) {
      if (this.servidor.servidorSrh2) {
        if (this.servidor.servidorSrh2.nrFnTrbSrv) {
          this.ramal = this.servidor.servidorSrh2.nrFnTrbSrv.toString();
        }
      }
    }
    // this.servidor$= this.servService.getServidorAtualRedirecionando('');
    ////console.log('RAMAL-SERVIDOR');
    ////console.log(this.servidor);
    this.mostrarEdicaoRamal = this.ramal === '';
    this.carregando = false;
    /*
    if (this.servidor) {
      this.servidorSrh2$ = this.service
        .getServidorSrh2(this.servidor.nrMatricula)
        .pipe(
          tap(a => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError(e => {
            this.handleError(e);
            return empty();
          })
        );
    }
    */
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }
}
